import { memo, useCallback } from 'react';

import { AtSignIcon } from '@air/design-icons';

import { WorkspaceAgentActionsMenuKeyboardHint } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/actions-menu/WorkspaceAgentActionsMenuKeyboardHint';
import { WORKSPACE_AGENT_ACTIONS_MENU_ADD_REFERENCE_KEYBOARD_HINT } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentActionsMenuLayout';
import { preserveWorkspaceAgentComposerFocus } from '~/components/v2/components/workspace/workspace-agent-panel/utils/preserveWorkspaceAgentComposerFocus';

export type WorkspaceAgentActionsMenuAddReferenceRowProps = {
  label: string;
  onAddReference: () => void;
};

export const WorkspaceAgentActionsMenuAddReferenceRow = memo(
  ({ label, onAddReference }: WorkspaceAgentActionsMenuAddReferenceRowProps) => {
    const handleClick = useCallback(() => {
      onAddReference();
    }, [onAddReference]);

    return (
      <button
        className="flex w-full min-w-0 items-center gap-2 rounded-6 px-2 py-2 text-left text-12 leading-4 ads:hover:bg-hover-subtle hover:bg-gray-4"
        data-testid="WORKSPACE_AGENT_ACTIONS_MENU_ADD_REFERENCE"
        onClick={handleClick}
        onMouseDown={preserveWorkspaceAgentComposerFocus}
        type="button"
      >
        <AtSignIcon aria-hidden className="shrink-0 ads:text-icon-default text-gray-10" size="sm" />
        <span className="min-w-0 flex-1 truncate ads:text-primary text-gray-12">{label}</span>
        <WorkspaceAgentActionsMenuKeyboardHint hint={WORKSPACE_AGENT_ACTIONS_MENU_ADD_REFERENCE_KEYBOARD_HINT} />
      </button>
    );
  },
);

WorkspaceAgentActionsMenuAddReferenceRow.displayName = 'WorkspaceAgentActionsMenuAddReferenceRow';
